import { createState, State, useState } from '@hookstate/core';
import { throttle } from 'lodash';

interface StateValues {
    activeSpeakers: string[]
}

const getStartValues = (): StateValues => {
    return {
        activeSpeakers: []
    }
}
const state = createState<StateValues>(getStartValues())

export interface ActiveSpeakerContext {
    getActiveSpeakers: () => string[],
    isActiveSpeaker: (attendeeId?: string | null) => boolean
}

const createStateWrapper = (state: State<StateValues>) => {
    const activeSpeakerCallback = throttle((activeSpeakers: string[]) => {
        state.set(prev => {
            prev.activeSpeakers = activeSpeakers
            return prev
        })
    }, 1000)

    return ({
        getActiveSpeakers: () => {
            return state.value.activeSpeakers
        },
        isActiveSpeaker: (attendeeId?: string | null) => {
            return attendeeId ? state.value.activeSpeakers.indexOf(attendeeId) > -1 : false
        },
        setActiveSpeakers: (activeSpeakers: string[]) => {
            activeSpeakerCallback(activeSpeakers)
        }
    })
}

export const accessActiveSpeakerContext = createStateWrapper(state)
export const useActiveSpeakerContext = (): ActiveSpeakerContext => createStateWrapper(useState(state))